module.exports = __webpack_public_path__ + "img/minus.2a444afd.svg";